import moment from 'moment-timezone'
import { BOOKING_FILTERS } from 'apps/booking/constants/bookingFilters'
import { updateCheckboxFilters } from 'utils/updateCheckboxFilters'
import { FORMATS } from 'constants/datetime'

const { company } = BOOKING_FILTERS

const updateFilters = (filter, value, state) => {
  const filtersObj = {
    checkboxFilters: { checkboxFilters: value },
    myLoads: { myLoads: value, company: null },
    myIssues: { myIssues: value },
    equipment: { equipment: value },
    podIds: { podIds: value, myLoads: false },
    pickupLocation: { pickupLocation: value, pickupRegion: '' },
    deliveryLocation: { deliveryLocation: value, deliveryRegion: '' },
    pickupRegion: { pickupRegion: value, pickupLocation: { city: '', state: '', postalCode: '' } },
    deliveryRegion: {
      deliveryRegion: value,
      deliveryLocation: { city: '', state: '', postalCode: '' },
    },
    pickupDates: { pickupDates: value },
    deliveryDates: { deliveryDates: value },
    query: { query: value },
    radius: { radius: value },
    stateOptions: { stateOptions: value },
    status: { status: value },
    currentUserId: { currentUserId: value },
    pickupDateRange: { pickupDateRange: value },
    deliveryDateRange: { deliveryDateRange: value },
    needsTracking: { needsTracking: value },
    shipperRateType: { shipperRateType: value },
    pricingType: { pricingType: value },
    issueState: { issueState: value },
    brokerPodKey: { brokerPodKey: value },
  }

  if (filter !== 'checkboxFilters' && value) {
    const checkboxFilter = state.checkboxFilters.find(el => filter === el.value)
    if (checkboxFilter) {
      const nextValue = state.checkboxFilters.map(el => updateCheckboxFilters(checkboxFilter, el))
      return updateFilters('checkboxFilters', nextValue, state)
    }
  }
  return filtersObj[filter]
}

export const updateFiltersState = (filter, value, state) => {
  const updateCompany = () => {
    const { id, type } = value || {}
    return {
      company: id ? id.toString() : '',
      usersId: id || null,
      usersType: type || null,
      myLoads: false,
    }
  }

  if (filter === company) return updateCompany()
  return updateFilters(filter, value, state)
}

export const formatPickupDeliveryDates = value => {
  const { dateFormat, flatpickrDateTimeFormat } = FORMATS
  return Array.isArray(value)
    ? value.map(date => moment(date, flatpickrDateTimeFormat).format(dateFormat))
    : []
}

export const clearCheckboxDropdown = val =>
  val.map(item => {
    item.selected = false
    return item
  })
